// Must load before React / React DOM (instrumentation hooks).
import { scan } from 'react-scan';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { API_BASE_URL } from './utils/api';
import { logWarn } from './utils/log';
import './index.css';
import App from './App';

async function bootstrap() {
  let reactScanOn = false;
  if (process.env.NODE_ENV === 'development') {
    try {
      const ac = new AbortController();
      const t = setTimeout(() => ac.abort(), 2500);
      const res = await fetch(`${API_BASE_URL}/api/platform-config`, { signal: ac.signal });
      clearTimeout(t);
      if (!res.ok) {
        logWarn('bootstrap', `platform-config HTTP ${res.status} (react-scan off)`);
      } else {
        const raw = await res.text();
        try {
          const data = JSON.parse(raw);
          reactScanOn = data.enableReactScan === true;
        } catch {
          const hint = raw.trimStart().startsWith('<')
            ? 'Got HTML (often SPA index or proxy error) — open UI at http://localhost:3000 with npm run dev and API on :4000.'
            : 'Response was not JSON.';
          logWarn(
            'bootstrap',
            'platform-config:',
            hint,
            'Preview:',
            raw.slice(0, 100).replace(/\s+/g, ' ')
          );
        }
      }
    } catch (e) {
      logWarn(
        'bootstrap',
        'platform-config fetch failed:',
        e?.name === 'AbortError' ? 'timeout' : e?.message || e
      );
    }
  }

  scan({
    enabled: reactScanOn,
    showToolbar: reactScanOn
  });

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <AppErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </AppErrorBoundary>
    </React.StrictMode>
  );
}

bootstrap();
